import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { IEntitySearchDoc } from "rl-common/models/i-entity-search-doc";
import { IQueryNode } from "rl-common/models/i-query-node";
import { IWfRole } from "rl-common/services/company/company.models";
import { IKeyValueOption } from "../../workflow-details-actions/workflow-action-edit/workflow-action-edit.models";
import { IParty } from "rl-common/components/contacts/models/i-party";
import { ICharacteristicType } from "rl-common/models/i-characteristic-type";

export enum AssigneeType {
	WorkflowRole = 1,
	Users = 2,
	Party = 3
}

export enum TaskSequence {
	Any = 0
}

export enum DueDateUnits {
	NoDueDate = 0,
	Days = 1,
	Weeks = 2,
	Months = 3,
	BusinessDays = 4
}

export interface ITaskConfigurationGroupForm {
	queryNode: FormControl<IQueryNode | null>;
	assignments: FormArray<FormGroup<ITaskConfigurationAssignmentForm>>;
}

export interface ITaskConfigurationAssignmentForm {
	id: FormControl<string>;
	taskName: FormControl<string | null>;
	description: FormControl<string | null>;
	requiredCompletions: FormControl<number | null>;
	overrideCompletions: FormControl<boolean>;
	sequence: FormControl<IKeyValueOption | null>;
	dueDateQuantity: FormControl<number | null>;
	dueDateIncrements: FormControl<IKeyValueOption | null>;
	assignees: FormArray<FormGroup<ITaskAssignee>>;
}

export interface ITaskAssignee {
	assigneeType: FormControl<IKeyValueOption | null>;
	assigneeId: FormControl<number | null>;
	assigneeUser: FormControl<IEntitySearchDoc | null>;
	assigneeRole: FormControl<IWfRole | null>;
	assigneeCharType: FormControl<ICharacteristicType | null>;
	assigneeParty: FormControl<IParty | null>;
}
